/* tc-cart-recovery.js — Trove Cart cart drawer auto-recovery.
 *
 * Problem: the theme updates cart quantities with positional `line` indexes
 * via /cart/change.js. When a third-party app (e.g. Hoppy's free-gift
 * auto-removal, which runs on a ~500ms poll) changes the cart's lines
 * concurrently, the drawer's line index goes stale. Shopify answers
 * 422 "line parameter is invalid.", the theme shows a red error and the
 * drawer wedges on stale data until the page is reloaded.
 *
 * Fix: listen for the theme's `shopify:cart:error` event; when it carries
 * the stale-line error, re-render the cart from server truth using the
 * theme's own refresh path, and re-sync the header cart bubble (which also
 * goes stale because it listens to the same rejected update promise).
 *
 * Only reacts to this one specific error — every other cart error behaves
 * exactly as before.
 */
(function () {
  'use strict';

  var STALE_LINE_ERROR = 'line parameter is invalid';
  var COOLDOWN_MS = 3000;
  var lastRecoveryAt = 0;

  function errorTextOf(event) {
    try {
      if (event && typeof event.error === 'string') return event.error;
      if (event && event.detail && typeof event.detail.error === 'string')
        return event.detail.error;
    } catch (e) {
      /* ignore */
    }
    return '';
  }

  function refreshCartFromServer() {
    var now = Date.now();
    if (now - lastRecoveryAt < COOLDOWN_MS) return;
    lastRecoveryAt = now;

    // 1) Re-render every cart-items section from server truth. This drops
    //    the stale line-index state and clears the red error (fresh HTML
    //    has no error container unhidden).
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      try {
        if (typeof el.refreshCartSection === 'function') el.refreshCartSection();
      } catch (e) {
        /* never break the page */
      }
    });

    // 2) Re-sync the header cart bubble count from /cart.js.
    try {
      fetch('/cart.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          var icon = document.querySelector('cart-icon');
          if (icon && typeof icon.renderCartBubble === 'function') {
            icon.renderCartBubble(cart.item_count || 0, false);
          }
        })
        .catch(function () {
          /* ignore */
        });
    } catch (e) {
      /* ignore */
    }
  }

  document.addEventListener('shopify:cart:error', function (event) {
    if (errorTextOf(event).toLowerCase().indexOf(STALE_LINE_ERROR) !== -1) {
      refreshCartFromServer();
    }
  });
})();
